module.exports = __webpack_public_path__ + "static/media/7.95519537.svg";